import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import ContactAppResource from './ContactAppResource';
import OrganizationAppResource from './OrganizationAppResource';
import OrganizationRoleAppResource from './OrganizationRoleAppResource';
import StageTypeAppResource from './StageTypeAppResource';
import UserAppResource from './UserAppResource';
import WildAppResource from './WildAppResource';
import WorkspaceAppResource from './WorkspaceAppResource';
import WorkspaceTypeAppResource from './WorkspaceTypeAppResource';
import LuOrganizationOccupationAppResource from './LuOrganizationOccupationAppResource';
import WorkspaceOrganizationMemberAppResource from "./WorkspaceOrganizationMemberAppResource";
import ExternalListingAppResource from "./ExternalListingAppResource";
import TransactionAppResource from "./TransactionAppResource";
import Engine from "@milestoneslabs/milestones-js-engine";
import OrganizationSubscriptionPlanAppResource from "./OrganizationSubscriptionPlanAppResource";
import OrganizationMemberReportAppResource
    from './OrganizationMemberReportAppResource';

export const STATUSES = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    PENDING_INVITATION: 'pendingInvitation',
    PENDING_CONFIRMATION: 'pendingConfirmation',
    PENDING_APPROVAL: 'pendingApproval',
    REJECTED: 'rejected',
    REMOVED: 'removed',
};

class OrganizationMemberAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Organization-Member';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'organizations/members';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'organizationUuid',
            'userUuid',
            'contactUuid',
            'organizationRoleUuid',
            'status',
            'adminUuid',
            'organization',
            'user',
            'organizationRole',
            'contact',
            'messages',
            'workspaces',
            'workspaceTypes',
            'stageTypes',
            'taskAssignees',
            'organizationIndustryUuid',
            'organizationOccupationId',
            'organizationOccupation',
            'workspaceMemberships',
            'externalListings',
            'transactions',
            'organizationSubscriptionPlans',
            'report',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            organization: OrganizationAppResource,
            user: UserAppResource,
            organizationRole: OrganizationRoleAppResource,
            contact: ContactAppResource,
            messages: WildAppResource,
            workspaces: WorkspaceAppResource,
            workspaceTypes: WorkspaceTypeAppResource,
            stageTypes: StageTypeAppResource,
            organizationOccupation: LuOrganizationOccupationAppResource,
            workspaceMemberships: WorkspaceOrganizationMemberAppResource,
            externalListings: ExternalListingAppResource,
            transactions: TransactionAppResource,
            organizationSubscriptionPlans: OrganizationSubscriptionPlanAppResource,
            report: OrganizationMemberReportAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            organization: 'organization_uuid',
            user: 'user_uuid',
            organizationRole: 'organization_role_uuid',
            contact: 'contact_uuid',
            organizationOccupation: 'organization_occupation_id',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            organizationUuid: {
                type: 'string',
                presence: true,
            },
            userUuid: {
                type: 'string',
                presence: true,
            },
            organizationRoleUuid: {
                type: 'string',
                presence: true,
            },
            organizationOccupationId: {
                type: 'integer',
            },
            contactUuid: {
                type: 'string',
            },
            adminUuid: {
                type: 'string',
            }
        };
    }

    apiPaths (environment = null) {
        return {
            'exportUsers': Engine.apiHost + '/exports/organizations/members',
            ...super.apiPaths(),
        }
    }
}

export default OrganizationMemberAppResource;
